<template>
  <FeedbackFormModal
    :open="open"
    :title="SORTY_REPORT_COPY.title"
    :subtitle="SORTY_REPORT_COPY.subtitle"
    :reasons="SORTY_REPORT_REASONS"
    v-model:reason="selectedReason"
    v-model:comment="comment"
    :details-visible="detailsVisible"
    :submittable="submittable"
    :submitting="submitting"
    :busy="submitting"
    @update:open="(value) => !value && close()"
    @submit="submit"
  />
</template>

<script setup>
import { post } from '@/api';
import { analytics } from '@/observability/analytics';
import { EVENTS, PROPS } from '@/observability/events';
import FeedbackFormModal from '@/components/FeedbackFormModal.vue';
import { useSortyReportForm } from '@/composables/useSortyReportForm';
import { SORTY_REPORT_COPY, SORTY_REPORT_REASONS } from '@/utils/sortyReports';

const props = defineProps({
  open: { type: Boolean, default: false },
  // () => ({ surface, links, turns }) - read at submit time so the snapshot
  // includes whatever sorty said while the modal was open (voice keeps going).
  context: { type: Function, required: true },
});
const emit = defineEmits(['update:open', 'submitted']);

// Shape only: which surface, the reason enum and whether there was a comment.
function trackReport({ surface, reason, hasComment, questionUuid }) {
  analytics.track(EVENTS.SORTY_REPORTED, {
    [PROPS.REPORT_SURFACE]: surface,
    [PROPS.FLAG_REASON]: reason,
    [PROPS.HAS_COMMENT]: hasComment,
    [PROPS.QUESTION_UUID]: questionUuid,
  });
}

function close() {
  emit('update:open', false);
}

const {
  selectedReason,
  comment,
  submitting,
  detailsVisible,
  submittable,
  reset,
  submit,
} = useSortyReportForm({
  context: () => props.context(),
  api: { post },
  notify: { success: message.success, error: message.error },
  onSubmitted(report) {
    trackReport(report);
    emit('submitted', report);
  },
  onClose: close,
});

// Always a fresh form.
watch(
  () => props.open,
  (isOpen) => {
    if (isOpen) reset();
  }
);
</script>
